/* h2パーツ用のdivを動的に生成
---------------------------------------------- */
export const BOX_INNER_SPAN = {
  init: function (elements) {
    $('.c-box--layout01').wrapInner('<span />')
  },
}
